import CatalogComponent from "../components/catalog";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import { CatalogDataProps } from "../types/public";
import { addCatalog } from "../state-management/actions/catalog-actions";
import { useDispatch } from "react-redux";
import {
  setAlert,
  setAlertContext,
  setAlertSeverity,
} from "../state-management/actions/alerts-actions";
import { createNotificationData } from "../utils/createNotificationData";
import { addNotification } from "../state-management/actions/notification-actions";
export default function Catalog() {
  const { currentUserData, departmentsData, groupingData } =
    useSelector(selectGlobalState);
  const dispatch = useDispatch();
  const initialData: CatalogDataProps = {
    type: "landscape",
    title: "",
    designer: "",
    created_by: currentUserData._id,
    is_active: false,
    description: "",
    catalog: null,
  };

  const [formData, setFormData] = useState<CatalogDataProps>(initialData);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: CatalogDataProps): Promise<boolean> => {
    console.log("tap");
    try {
      setLoading(true);
      const data = values;

      const response = await addCatalog(data)(dispatch);
      if (response?.status === 200) {
        setFormData(initialData);
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("ثبت مقاله با موفقیت صورت پذیرفت"));
        const notificationData = createNotificationData({
          data,
          departmentsData,
          currentUserData,
          groupingData,
          type: "create",
          subject: "کاتالوگ",
        });
        await addNotification(notificationData)(dispatch);
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <CatalogComponent
      formData={formData}
      handleSubmit={handleSubmit}
      setFormData={setFormData}
      loading={loading}
      currentUserId={currentUserData}
    />
  );
}
